export default __webpack_public_path__ + "static/media/logo-shape-dark.473af05e.svg";